// extracted by mini-css-extract-plugin
module.exports = {"select-boxes":"Filters_select-boxes__TchZZ","portfolio-benchmark":"Filters_portfolio-benchmark__3GwRx"};